import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../styles/Specializations.css';

function TaxationLaw() {

  useEffect(() => {
    document.title = "Taxation Law - Legal Trails";  // Set Page Title
  }, []);


  return (
    <>
    <Navbar />
    <div className="law">
      
      <section className="specializations-detail">
        <div className="container">
          <div className="header-image">
            <img 
              src="./Taxation-Law-1.png" 
              alt="Taxation Law" 
              loading="lazy" 
              onLoad={(e) => e.target.style.opacity = 1}
              style={{ opacity: 0, transition: "opacity 0.3s ease-in-out" }} 
            />
          </div>
          <div className="content">
            <p>
              At Legal Trails, we go beyond traditional legal and accounting services—we are architects of financial success. With a passion for precision and an unwavering commitment to integrity, we serve as a beacon of trust in the complex world of finance. Our mission is to transform possibilities into realities, combining expertise with relentless determination to drive innovation and create meaningful impact.
            </p>
            <p>
              We believe in collaboration, partnering closely with our clients to co-create strategies that not only meet their goals but exceed their expectations. Our comprehensive Governance, Risk, and Compliance Advisory services empower clients to navigate the complexities of taxation law with confidence and ease. At Legal Trails, we are dedicated to fostering financial success through tailored solutions and strategic guidance.
            </p>
            <div className="button-container">
              <Link to="/contact">
                <button>Contact Us</button>
              </Link>
            </div>
          </div>
        </div>
      </section>
     
    </div>
    <Footer />
    </>
  );
}

export default TaxationLaw;
